import {
    FormFieldWidget,
    FormM2OSelectFieldWidget,
    FormStringFieldSingleWidget,
    ModelFieldType,
    SPI,
    ViewType,
    Widget,
} from '@kunlun/dependencies';
import { CoverFormStringField } from '../cover-string-field/CoverFormStringField';


@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: ViewType.Form,
        ttype: ModelFieldType.String,
        model: [
            'deli.retail.BackendRetailEipPartner'
        ],
        name: "meituanId",
        multi: false
    })
)
export class FormMeituanIdFieldWidget extends CoverFormStringField {
    public initialize(props) {
        super.initialize(props);
        return this;
    }
    @Widget.Watch('formData.meituanId')
    protected async watchMeituanId(value: string) {
        if (!value) {
            this.formData.address = undefined
            this.formData.contactPhone = undefined
        }
    }
    // @Widget.Method()
    // public change(value) {
    //     super.change(value)
    //     if (!value) {
    //         debugger
    //     }
    // }
}
